import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import staticRoutes from './routes'
import { setupI18NGuard } from './guard'
// import { setupPermissionGuard } from './permission'

const NotFoundRoutes: Array<RouteRecordRaw> = [
  {
    name: '404',
    path: '/404',
    meta: {
      title: '404',
      localeKey: '404',
    },
    component: () => import('@/views/404.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: '404' },
  },
]

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
  routes: [...staticRoutes, ...NotFoundRoutes],
})

setupI18NGuard(router)

// setupPermissionGuard(router)

export default router
